import { api } from '../../core/network/api';

export interface SocialLink {
  id: string;
  platform: string;
  url: string;
  icon: string;
  sortOrder: number;
  active: boolean;
  createdAt: string;
}

/** GET /api/cms/social-links — active social links from the core CMS (admin-managed, Admin → Social Links). */
export const fetchSocialLinks = () => api.get<SocialLink[]>('/cms/social-links');
